module.exports = __webpack_public_path__ + "img/sbb_logo.413a011f.png";